export default "/_next/static/images/5fb9e8d6e255dc0983671de53bad9fe3.png";